import { useMedia } from '@shopify/react-hooks';
import { useRef, useCallback } from 'react';

const bounceKeyframes = {
  transform: ['', 'translate3d(0,-20px,0)', ''],
  easing: 'ease-in-out'
};
const bounceOptions = {
  duration: 400
};
function useBounceAnimation({
  ref,
  disabled
}) {
  const prefersReducedMotion = useMedia('(prefers-reduced-motion: reduce)');
  const isBouncingRef = useRef(false);
  const bounce = useCallback(() => {
    if (prefersReducedMotion || disabled) {
      return;
    }
    const element = ref.current;
    if (!element || isBouncingRef.current) {
      return;
    }
    const bounce = element.animate(bounceKeyframes, bounceOptions);
    if (bounce.playState === 'running') {
      isBouncingRef.current = true;
    }
    bounce.onfinish = () => {
      isBouncingRef.current = false;
    };
  }, [disabled, prefersReducedMotion, ref]);
  return bounce;
}

export { useBounceAnimation };
